import http from 'conversations-http/clients/http';

// GetThreadDeliveryIdentifierDataResponse from cv-backend-services is incorrect, blocked by https://git.hubteam.com/HubSpot/ApiTooling/issues/2402
// Type cannot be overridden, per https://git.hubteam.com/HubSpot/frontend-dev-tooling/issues/582
export const fetchThreadDeliveryIdentifierData = ({
  threadId
}) => {
  return http.get(`conversations-threads/v1/thread-attributes/${threadId}/delivery-identifiers`);
};